'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { composerStyles } from '#pplx/frontend/composer-sdk/styles.js';
import { useComposer } from '#pplx/frontend/composer-sdk/useComposer.js';
import classNames from 'classnames';
import React from 'react';
export const LeftAttribution = React.memo(function LeftAttribution({ children, }) {
    const { isExpanded } = useComposer();
    return children !== null ? (_jsx("div", { className: classNames(...composerStyles.attribution.left.base, {
            [composerStyles.attribution.left.expanded]: isExpanded,
            [composerStyles.attribution.left.compact]: !isExpanded,
        }), children: children })) : null;
});
//# sourceMappingURL=LeftAttribution.js.map